import {
    GET_INTERNAL_MOVEMENT_LIST_SUCCESS,GET_INTERNAL_MOVEMENT_LIST_FAILURE,GET_INTERNAL_MOVEMENT_LIST_PROGRESS,
    ADD_INTERNAL_MOVEMENT_SUCCESS,ADD_INTERNAL_MOVEMENT_FAILURE,ADD_INTERNAL_MOVEMENT_PROGRESS,
    EDIT_DELETE_INTERNAL_MOVEMENT_SUCCESS,EDIT_DELETE_INTERNAL_MOVEMENT_FAILURE,EDIT_DELETE_INTERNAL_MOVEMENT_PROGRESS,


    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    internal_movement: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const internal_movement_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_INTERNAL_MOVEMENT_LIST_SUCCESS:
            return { ...state, internal_movement: action.internal_movement, loading: false };
        case GET_INTERNAL_MOVEMENT_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_INTERNAL_MOVEMENT_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_INTERNAL_MOVEMENT_PROGRESS:
            return { ...state, loading: true };
        case ADD_INTERNAL_MOVEMENT_SUCCESS:
            return { ...state, internal_movement: [...state.internal_movement, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_INTERNAL_MOVEMENT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_INTERNAL_MOVEMENT_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_INTERNAL_MOVEMENT_SUCCESS:
            return {
                ...state,
                internal_movement: state.internal_movement.map((internal_movement) =>
                    internal_movement.id === action.payload.id ? action.payload : internal_movement
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_INTERNAL_MOVEMENT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default internal_movement_reducer;